import http from '@/utils/http'

export function addUser(data){
    return http.post('/users',data)
}
export function editUser(id,data){
    return http.put(`/users/${id}`,data)
}
export function getUser(id){
    return http(`/users/${id}`)
}

